import { ExecutionStatus, ExecutionStatusSummary } from '@qality/common-model';

const isStatusSummaryEmpty = (
  statusSummary: ExecutionStatusSummary
): boolean => {
  if (!statusSummary) {
    return true;
  }

  return statusSummary.filter((s) => s.total > 0).length === 0;
};

const createSummary = (
  statusSummary: Array<Pick<ExecutionStatusSummary[number], 'status' | 'total'>>
): ExecutionStatusSummary => {
  const total = statusSummary.reduce((sum, s) => {
    return sum + s.total;
  }, 0);

  if (total === 0) {
    return statusSummary.map((s) => {
      return {
        ...s,
        percent: 0,
      };
    });
  }

  const newStatusSummary = statusSummary.map((s) => {
    return { ...s, percent: (s.total * 100) / total };
  });

  return [...newStatusSummary].sort((a, b) => {
    return a.status.position - b.status.position;
  });
};

const updateSummaryWithAddedStatuses = (
  statusSummary: ExecutionStatusSummary,
  addedStatuses: Array<ExecutionStatus>
): ExecutionStatusSummary => {
  const total = statusSummary.reduce((sum, s) => {
    return sum + s.total;
  }, addedStatuses.length);

  if (total === 0) {
    return statusSummary.map((s) => {
      return {
        ...s,
        total: 0,
        percent: 0,
      };
    });
  }

  const newStatusSummary = statusSummary.map((s) => {
    const statusNewTotal =
      s.total +
      addedStatuses.filter((addedStatus) => addedStatus.id === s.status.id)
        .length;

    return {
      ...s,
      total: statusNewTotal,
      percent: (statusNewTotal * 100) / total,
    };
  });

  return [...newStatusSummary].sort((a, b) => {
    return a.status.position - b.status.position;
  });
};

const updateSummaryWithRemovedStatuses = (
  statusSummary: ExecutionStatusSummary,
  removedStatuses: Array<ExecutionStatus>
): ExecutionStatusSummary => {
  const total = statusSummary.reduce((sum, s) => {
    return sum + s.total;
  }, -removedStatuses.length);

  if (total <= 0) {
    return statusSummary.map((s) => {
      return {
        ...s,
        total: 0,
        percent: 0,
      };
    });
  }

  const newStatusSummary = statusSummary.map((s) => {
    const statusNewTotal =
      s.total -
      removedStatuses.filter(
        (removedStatus) => removedStatus.id === s.status.id
      ).length;

    return {
      ...s,
      total: statusNewTotal,
      percent: (statusNewTotal * 100) / total,
    };
  });

  return [...newStatusSummary].sort((a, b) => {
    return a.status.position - b.status.position;
  });
};

export const ExecutionStatusUtils = {
  isStatusSummaryEmpty,
  createSummary,
  updateSummaryWithAddedStatuses,
  updateSummaryWithRemovedStatuses,
};
